import MarketplaceTab from "./marketplaceTab.container";

export default MarketplaceTab;
